import React, { useEffect, useState } from 'react'
import { Header } from '../Core/Header'
import { Footer } from '../Core/Footer'
import { calculateMedicalTestsBill, getMedicalTests, orderMedicalTests } from '../Services/Operations/ProductAPI'
import { baseURL } from '../Services/api_endpoints'
import { toast } from 'react-toastify'

const MedicalTest = () => {
      const [service, setService] = useState([]);
      const [selected, setSelected] = React.useState([]);
           const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  
  const currentServices = service?.slice(indexOfFirst, indexOfLast);

  const handleChange = (value) => {
  setSelected((prev) =>
    prev.includes(value)
      ? prev.filter((v) => v !== value) // pull
      : [...prev, value]                // push
  );
};

const getAllTests=async()=>{
    try {
        const res=await getMedicalTests()
        console.log(res);
        if(res.status===200){
            setService(res.data)
        }
        
    } catch (error) {
        console.log(error);
        
    }
}

const handleCalculate=async()=>{
    try {
      if(selected.length<1){
        toast.info("Atleast select one service")
        return
      }
      let data={
        serviceIds: selected
    }
    console.log(data);
    
        const res=await calculateMedicalTestsBill(data)
        console.log(res);
        if(res.status===200){
          handleOrderTest(res.data.grandTotal)
        }
        
        
    } catch (error) {
       console.log(error);
        
    }
}

const handleOrderTest=async(data)=>{
    try {
      console.log(data);
      
        const res=await orderMedicalTests(data)
        console.log(res);
        if(res.status===200){
          toast.success("Test booked successfully")
        }
        
    } catch (error) {
       console.log(error);
        
    }
}

useEffect(() => {
    getAllTests()
}, [])


  return (
    <div>
     
      <Header/>
      <div style={{height:"100vh",padding:"100px 20px",marginTop:"100px"}}>
        <div style={{display:"flex",justifyContent:"space-between",padding:"20px"}}>
          <p style={{fontSize:"22px",fontWeight:"600"}}>Select test and book order </p>
          <button
          onClick={()=>handleCalculate()}>Order</button>
        </div>
         <div className="table-responsive card">

                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{textAlign:"center"}}>Id</th>
                        <th style={{textAlign:"center"}}>serviceName</th>
                       <th style={{textAlign:"center"}}>shortName</th>
                        <th style={{textAlign:"center"}}>image</th>
                         <th style={{textAlign:"center"}}>online status</th>
                          <th style={{textAlign:"center"}}>status</th>
                        <th style={{textAlign:"center"}}>description</th>
                         <th style={{textAlign:"center"}}>action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentServices?.map((service,ind) => (
                        <tr key={service?.id}>
                          <td>{indexOfFirst+ind+1}</td>
                          <td>{service?.serviceName}</td>
                         <td>{service?.serviceShortName}</td>
                          <td>
                            <img src={baseURL+'api'+ service?.serviceImage}
                            style={{width:"50px",borderRadius:"50%"}}
                            />
                          </td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                service?.onlineAvailable
                                  ? "btn-primary"
                                  : "btn-danger"
                              }`}
                              
                            >
                              {service?.onlineAvailable===1
                                ? "Active"
                                : "Inactive"}
                            </button>
                          </td>
                           <td>
                            <button
                              className={`btn btn-sm ${
                                service?.status
                                  ? "btn-primary"
                                  : "btn-danger"
                              }`}
                             
                            >
                              {service?.status===1 ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <p onClick={()=>handleOrderTest()}>{service.serviceDescription}</p>
                           
                          </td>
                          <td>
                            <input
                            type='checkbox'
                             value={service.id}
                         checked={selected.includes(service.id)}
                         onChange={() => handleChange(service.id)}
                            />
                           
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                               <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(service.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(service.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>
      </div>
       <Footer/>
    </div>
  )
}

export default MedicalTest
